import { FiKey } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

const ButtonTableResetPassword = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "yellow",
    className: `w-[32px] h-[32px] ml-[12px] flex justify-center items-center rounded-[4px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      <FiKey className="text-gray-600 font-medium" size={20} />
    </Button>
  );
};

export default ButtonTableResetPassword;
